<script setup lang="ts">
import { breakpointsTailwind } from '@vueuse/core'
import IconsMagic from '~/pages/magic/@components/Icons/Magic/index.vue'

const { colors } = useTheme()

const breakpoints = useBreakpoints(breakpointsTailwind)

const isMobile = breakpoints.smallerOrEqual('md')
</script>

<template>
  <section w-full mb-100px>
    <div w-full p="40px <md:0">
      <div w-full flex justify-center :style="{ backgroundColor: colors.purple }" rounded="6 <md:0" p-20px>
        <div w="600px <md:full">
          <ClientOnly>
            <LottiePlayerDot
              src="/images/Magic/lotties/DiscoverPrompt.lottie"
              rounded-3
            />
          </ClientOnly>
        </div>
      </div>

      <div flex-col justify-center items-center p-12px>
        <div flex="~ row <md:col-reverse" justify-between pt-40px pl="0 <md:12px" pr="0 <md:12px" pt="40px <md:20px">
          <div flex>
            <Heading w-350px style="font-family: Circular Std Bold, sans-serif; lineHeight: 40px" level="1">
              Elevate your workflow and enhance your AI experience with Magic.
            </Heading>
          </div>

          <div>
            <div flex="~ row" space-x-2 mb-28px>
              <IconsMagic />

              <div flex="~ col" space-y-2>
                <div flex>
                  <IconStarFivePoints :stroke-color="colors.yellowStar" />
                  <IconStarFivePoints :stroke-color="colors.yellowStar" />
                  <IconStarFivePoints :stroke-color="colors.yellowStar" />
                  <IconStarFivePoints :stroke-color="colors.yellowStar" />
                  <IconStarFivePoints :stroke-color="colors.yellowStar" />
                </div>

                <Text style="font-family: Circular Std Book, sans-serif" variant="caption" :color="colors.darkerGray">
                  Reviews on Chrome Store
                </Text>
              </div>
            </div>
            <NuxtLink
              v-if="!isMobile"
              :to="LINKS.extension.magicChromeWebStore"
              target="_blank"
              flex
              items-center
              justify-center
              bg-transparent
              b-black
              b-2
              rounded-6
              color-black
              font-500
              p-10px
              w-350px
              hover-bg-black
              hover-color-white
            >
              <IconsMagic size="25" background-color="transparent" color="currentColor" />

              Install Magic
            </NuxtLink>
          </div>
        </div>

        <NuxtLink
          v-if="isMobile"
          :to="LINKS.extension.magicChromeWebStore"
          target="_blank"
          w-full
          flex
          items-center
          justify-center
          bg-transparent
          b-black
          b-2
          rounded-6
          color-black
          font-500
          p-10px
          mt-28px
          mb-36px
          hover-bg-black
          hover-color-white
        >
          <IconsMagic size="25" background-color="transparent" color="currentColor" />

          Install Magic
        </NuxtLink>
      </div>
    </div>
  </section>
</template>
